export const isNonEmpty = (s) => Boolean((s ?? "").trim());

export const isValidEmail = (email) =>
  /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email).toLowerCase());

/** Plug in a stronger GB validator later if needed */
export const isValidPostcodeLoose = (pc) => /^[A-Z0-9 ]{5,8}$/.test(pc);

const UK_POSTCODE_REGEX =
  /^([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9][A-Za-z]?))))\s?[0-9][A-Za-z]{2})$/;

export const normalizePostcode = (pc) =>
  String(pc ?? "")
    .toUpperCase()
    .replace(/[^A-Z0-9 ]/g, "")
    .replace(/\s+/g, " ")
    .trim();

export const isValidUKPostcode = (pc) =>
  UK_POSTCODE_REGEX.test(normalizePostcode(pc));

// DD-MM-YYYY
// DD/MM/YYYY
const DOB_REGEX = /^\d{2}\/\d{2}\/\d{4}$/;

export const isValidDateDDMMYYYY = (s) => {
  if (!DOB_REGEX.test(s)) return false;

  const [dd, mm, yyyy] = s.split("/").map(Number);

  // Year check
  if (yyyy < 1900) return false;

  const dt = new Date(yyyy, mm - 1, dd);

  // Ensure valid real date (e.g. no 32/13/2020)
  const same =
    dt.getFullYear() === yyyy &&
    dt.getMonth() === mm - 1 &&
    dt.getDate() === dd;

  // Remove time part for accurate comparison
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  dt.setHours(0, 0, 0, 0);

  // Not in future
  const notFuture = dt <= today;

  return same && notFuture;
};